const TENSES = [
  {
    id: "indicative",
    title: "Indicatif",
    tenses: [
      {
        id: "present",
        title: "Présent",
      },
      {
        id: "imperfect",
        title: "Imparfait",
      },
      {
        id: "future",
        title: "Futur",
      },
      {
        id: "simple-past",
        title: "Passé simple",
      },
      {
        id: "present+pp",
        title: "Passé composé",
      },
      {
        id: "imperfect+pp",
        title: "Plus-que-parfait",
      },
      {
        id: "future+pp",
        title: "Futur antérieur",
      },
      {
        id: "simple-past+pp",
        title: "Passé antérieur",
      },
    ],
  },
  {
    id: "conditional",
    title: "Conditionnel",
    tenses: [
      {
        id: "present",
        title: "Présent",
      },
      {
        id: "present+pp",
        title: "Passé",
      },
    ],
  },
  {
    id: "subjunctive",
    title: "Subjonctif",
    tenses: [
      {
        id: "present",
        title: "Présent",
      },
      {
        id: "imperfect",
        title: "Imparfait",
      },
      {
        id: "present+pp",
        title: "Passé",
      },
      {
        id: "imperfect+pp",
        title: "Plus-que-parfait",
      },
    ],
  },
  {
    id: "imperative",
    title: "Impératif",
    tenses: [
      {
        id: "imperative-present",
        title: "Présent",
      },
      {
        id: "imperative-present+pp",
        title: "Passé",
      },
    ],
  },
  {
    id: "participle",
    title: "Participe",
    tenses: [
      {
        id: "present",
        title: "Présent",
      },
      {
        id: "past",
        title: "Passé",
      },
    ],
  },
  {
    id: "infinitive",
    title: "Infinitif",
    tenses: [
      {
        id: "infinitive-present",
        title: "Présent",
      },
      {
        id: "infinitive-present+pp",
        title: "Passé",
      },
    ],
  },
];

const getTenseLabel = (t) => {
  const parts = t.match(/^([^-]*)-(.*)/);
  const mode = TENSES.find((m) => m.id === parts[1]);

  if (!mode) {
    return t;
  }

  return mode.title + " " + (mode.tenses.find((t) => t.id === parts[2]) || { title: t }).title;
};

const GROUPS = [
  {
    id: "1",
    title: "1er groupe (ER)",
  },
  {
    id: "2",
    title: "2ème groupe (IR - ISSANT)",
  },
  {
    id: "3",
    title: "3ème groupe (IR - ANT) et autres",
  },
  {
    id: "aux",
    title: "Auxiliaires (être et avoir)",
  },
];

const PRONOUNS = [
  "1ère p. du singulier",
  "2ème p. du singulier",
  "3ème p. du singulier",
  "1ère p. du pluriel",
  "2ème p. du pluriel",
  "3ème p. du pluriel",
];

const PRONOUNS_SHORT = ["Je", "Tu", "Il/Elle/On", "Nous", "Vous", "Ils"];

export { TENSES, GROUPS, getTenseLabel, PRONOUNS, PRONOUNS_SHORT };
